import { z } from "zod";
export const Config2WidgetNames = z.object({ names: z.array(z.array(z.string())) });
export const Config2GetWidgetsArgs = z.object({ name: z.array(z.string()) });
//# sourceMappingURL=config2.js.map